import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useSelector } from 'react-redux';
import { formatDinero } from '../../../utils/formatDinero';
import EstatusAereos from '../Estatus';
import { useHistory } from 'react-router-dom';
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn"
import FPagarAereo from '../FPagarAereo';
import { FormatoFechaIso } from '../../../utils/FormatFecha';
import BotonValidarAereo from '../BotonValidar';
import { EstatusCompra } from '../../../constant/catEstatusCompra';
import ButtonClienteDetalle from "./../../../global/ButtonClienteDetalle"
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const TGrupoAereo = () => {
    const classes = useStyles();
    const history = useHistory()
    const { grupos, grupo } = useSelector(store => store.aereos)
    const rows = grupos
    const onReturn = () => {
        history.goBack()
    }
    return (
        <div>
            <div style={{ margin: "2% 0", display: "flex", justifyContent: "space-between" }}>
                <FPagarAereo />
                <Button variant='contained' onClick={onReturn}>
                    <KeyboardReturnIcon />
                    Regresar
                </Button>
            </div>
            <div style={{ margin: "1% 0", display: "flex", justifyContent: "space-around" }}>
                <p>Paquete: {grupo?.Paquete}</p>
                <p>Fecha Salida: {FormatoFechaIso({ date: grupo?.FechaViaje, formato: "dd MMMM yyyy" })}</p>
                <p>Clave Viaje: {grupo?.ClaveViaje}</p>
                <p>Total Pax: {grupo?.totalPasajeros}</p>
                <p>No. Viajes: {grupo?.PlazaAereo} / {grupo?.PlazaTotal}</p>
            </div>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align='center'>#</TableCell>
                            <TableCell align="center">Referencia</TableCell>
                            <TableCell align="center">Paquete</TableCell>
                            <TableCell align="center">No. Pax</TableCell>
                            <TableCell align="center">Monto Paquete</TableCell>
                            <TableCell align="center">Monto Acumulado</TableCell>
                            <TableCell align="center">Versión</TableCell>
                            <TableCell align="center">Habitación</TableCell>
                            <TableCell align="center">Estatus</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={row?.Meta.Id_Meta}>
                                <TableCell component="th" scope="row">
                                    {index + 1}
                                </TableCell>
                                <TableCell align="center">
                                    <ButtonClienteDetalle referencia={row?.Meta?.Referencia} />
                                </TableCell>
                                <TableCell align="center">{row?.Meta?.Paquete?.Nombre}</TableCell>
                                <TableCell align="center">{row?.Meta?.Paquete?.Numero_Personas}</TableCell>
                                <TableCell align="center">{`${formatDinero(row?.Meta?.Paquete?.Monto_Paquete)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}</TableCell>
                                <TableCell align="center">{`${formatDinero(row?.Meta?.Paquete?.Cotizacion?.Suma)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}</TableCell>
                                <TableCell align="center">{row?.Meta?.Paquete?.ClaveVersion}</TableCell>
                                <TableCell align="center">
                                    {
                                        row?.lHabitacion?.map((habitacion, index) => {
                                            return (
                                                <p index={index}>{`${habitacion?.Cantidad} Hab. ${habitacion?.TipoPlaza?.Descripcion}`}</p>
                                            )
                                        })
                                    }
                                </TableCell>
                                <TableCell align="center">
                                    {
                                        (row?.DscEstatus) ? `${row?.DscEstatus}` :
                                            <EstatusAereos estatus={row?.Compra?.estatusCompra?.idEstatusCompra} />
                                    }
                                    {
                                        (!row?.DscEstatus && row?.Compra?.estatusCompra?.idEstatusCompra === EstatusCompra.NoAplica) &&
                                        <BotonValidarAereo
                                            idCuenta={row?.Meta?.Paquete?.cuenta?.Id_Cuenta}
                                            idMoneda={row?.Meta?.Paquete?.Cotizacion?.Moneda?.id_moneda}
                                            idPaquete={row?.Meta?.Paquete?.Id_Paquete}
                                        />
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
export default TGrupoAereo